import React, { useState } from "react";
import { useNavigate, Outlet, Link, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import "./AdminLayout.css";

const AdminLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/admin/login");
    } catch (error) {
      console.error("로그아웃 중 오류 발생:", error);
    }
  };

  const menuItems = [
    { path: "/admin/dashboard", label: "대시보드", icon: "📊" },
    { path: "/admin/wedding-info", label: "웨딩 정보", icon: "💍" },
    { path: "/admin/messages", label: "문구 관리", icon: "💬" },
    { path: "/admin/gallery", label: "갤러리 관리", icon: "🖼️" },
    { path: "/admin/page-settings", label: "페이지 설정", icon: "⚙️" },
    { path: "/admin/emails", label: "이메일 관리", icon: "✉️" },
    { path: "/admin/guestbook", label: "축하한마디 관리", icon: "💬" },
  ];

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <div className="header-left">
          <button
            className="sidebar-toggle"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            ☰
          </button>
          <h1>관리자 대시보드</h1>
        </div>
        <div className="header-right">
          <span className="user-email">{user?.email}</span>
          <button onClick={handleLogout} className="logout-button">
            로그아웃
          </button>
        </div>
      </header>

      <div className="admin-container">
        <aside className={`admin-sidebar ${isSidebarOpen ? "open" : "closed"}`}>
          <nav>
            <ul>
              {menuItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={location.pathname === item.path ? "active" : ""}
                  >
                    <span className="icon">{item.icon}</span>
                    <span className="label">{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
